import { useState } from "react";

interface ResourceSelected {
  Arn: string;
  ResourceType: string;
  Region: string;
  OwningAccountId: string;
}

const useSelectedResourceTaggingResources = () => {
    const [resourcesSelected, setResourcesSelected] = useState<string[]>([]);
    const [regionsSelected, setRegionsSelected] = useState<string[]>([]);

    const selectedResources = (resources: ResourceSelected[]) => {
        const resource_arns = Array.from(new Set(resources.map((r) => r.Arn)));
        const resource_regions = Array.from(
            new Set(
                resources
                .map((r) => r.Region)
                .filter((region) => region.toLowerCase() !== "global")
            )
        );
        setResourcesSelected(resource_arns);
        setRegionsSelected(resource_regions);
    };    
    return {
        selectedResources, resourcesSelected, regionsSelected
    }
};

export { useSelectedResourceTaggingResources };